import React, { memo } from 'react'
import startCase from 'lodash/startCase'
import toLower from 'lodash/toLower'
import moment from 'moment'
import { Typography } from 'transfix-ui/core'

export interface IGreetingHeaderProps {
  firstName?: string
}

export const GreetingHeader = memo<IGreetingHeaderProps>(({ firstName = '' }) => {
  const isMorning = moment().hours() < 12
  const greeting = isMorning ? 'Good morning' : 'Good afternoon'
  const firstNameFormatted = startCase(toLower(firstName))

  return (
    <Typography variant='h2'>
      {greeting}
      {firstName ? `, ${firstNameFormatted}` : ''}
    </Typography>
  )
})
